import { Component } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { UserPermissionsPage } from './page';


@Component({
  selector: 'app-page-userPermissions',
  template: '<div class="react-page" #container></div>'
})
export class PageUserPermissionsComponent extends ReactPageComponent {
  get Component(){
    return UserPermissionsPage;
  }
}
